// Shared fetch wrapper for our API. It must stay on window.fetch (not axios)
// so the 401 auto-logout guard in utils/auth.js sees every request.
import { apiUrl } from '../constants/apiEndpoints';

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

// Plain objects are sent as JSON; FormData and strings are sent as-is.
// The admin session is an httpOnly cookie; auth: false omits it (public
// candidate calls). Resolves with the parsed JSON body (or { status, data }
// with includeStatus), or throws ApiError on a non-2xx response.
export async function apiFetch(path, { body, headers, auth = true, includeStatus = false, ...init } = {}) {
  const h = new Headers(headers);

  let payload = body;
  if (body !== undefined && !(body instanceof FormData) && typeof body !== 'string') {
    h.set('Content-Type', 'application/json');
    payload = JSON.stringify(body);
  }

  const res = await fetch(apiUrl(path), {
    ...init,
    headers: h,
    body: payload,
    credentials: auth ? 'include' : 'omit',
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new ApiError(data?.error || data?.message || `Request failed (${res.status})`, res.status, data);
  }
  return includeStatus ? { status: res.status, data } : data;
}
